import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useDocSignService } from 'app/utils/services/docSignService';
import { useEffect, useState } from 'react';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';
import { useForm } from 'react-hook-form';
import { useLoginWithEmailService } from 'app/utils/services/authService';

const useDocSign = () => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [firstInput, setFirstInput] = useState<string | undefined>('');
  const [secondInput, setSecondInput] = useState<string | undefined>('');

  const [showAsanModal, setShowAsanModal] = useState(true);

  const { isLoadingLogWithEmail, dataLogWithEmail, loginMutation } = useLoginWithEmailService();

  useEffect(() => {
    if (dataLogWithEmail?.form_id === 'asan_wait') {
      setShowAsanModal(true);
    }
  }, [dataLogWithEmail]);

  const location = useLocation();
  const data = location.state;

  const { isLoadingDocSign, dataDocSign, docSignMutation } = useDocSignService();
  const { handleRedirect } = useRedirectWithFormId();

  const { register, handleSubmit } = useForm();

  useEffect(() => {
    if (dataDocSign !== undefined) {
      handleRedirect(dataDocSign);
    }
  }, [dataDocSign]);

  const handleGetDoc = (docId: string) => {
    docSignMutation({ data: { documents_id: docId }, url: `${data?.path_url}?business_key=${data?.business_key}` });
  };

  const handleCheck = () => {
    setChecked(!checked);
  };

  const handleSign = () => {
    docSignMutation({
      data: { confirm_documents: 'yes' },
      url: `${data?.path_url}?business_key=${data?.business_key}`,
    });
  };

  const handleOnChangeAsanPhone = (event: any) => {
    const inputValue = event.target.value;
    const pattern = /^(\d{2})(\d{0,3})(\d{0,2})(\d{0,2})$/;
    const replacement = '$1 $2 $3 $4';

    const formattedString = inputValue
      .replace(/[^\dA-Z]/g, '')
      .replace(pattern, replacement)
      .trim();

    setFirstInput(formattedString);
  };

  const handleOnChangeAsanID = (event: any) => {
    const inputValue = event.target.value;
    const formattedString = inputValue.replace(/[^\dA-Z]/g, '').trim();

    setSecondInput(formattedString);
  };

  const handleOnSubmit = (asanData: any): any => {
    loginMutation({ ...asanData, asan_imza_phone: `994${asanData.asan_imza_phone.replace(/\s+/g, '')}` });
  };

  const handleSubmitForm = handleSubmit(handleOnSubmit);

  return {
    t,
    data,
    checked,
    showModal,
    showAsanModal,
    firstInput,
    secondInput,
    isLoadingLogWithEmail,
    dataLogWithEmail,
    register,
    handleGetDoc,
    handleOnChangeAsanPhone,
    handleOnChangeAsanID,
    handleSubmitForm,
    handleCheck,
    handleSign,
  };
};

export default useDocSign;
